import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { TokenService } from '../services/token.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {

    constructor(
        private router: Router,
        private tokenService: TokenService
    ) { }
  
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const currentUser = this.tokenService.isLoggedIn();
        if(next.routeConfig?.path === 'employeeauthorizeclearance'){
          return true;
        }else if(next.routeConfig?.path === 'employeeonboarding'){
          return true;
        }
        else if (currentUser) {
          return true;
        }else {
          this.router.navigate(['/signin']);
          return false;
        }
        
    }
}